module.exports = __webpack_public_path__ + "img/delivered.cc1e5c05.svg";